import { Card, Skeleton } from "antd";
import "./css/inspiration-card-web.css";

const InspirationSkeletonCard = () => (
    <Card
        className="editorial-card inspiration-skeleton-card"
        bodyStyle={{ padding: 0, display: "flex", flexDirection: "column" }}
    >
        <div className="editorial-media inspiration-skeleton-media">
            <Skeleton.Image active />
        </div>
        <div className="editorial-footer inspiration-skeleton-card__footer">
            <div className="editorial-footer-inner">
                <Skeleton.Avatar active size={44} shape="square" className="inspiration-skeleton-card__avatar" />
                <div className="inspiration-skeleton-card__lines">
                    <Skeleton
                        active
                        title={false}
                        paragraph={{
                            rows: 2,
                            width: ["88%", "52%"],
                        }}
                    />
                </div>
            </div>
            <div className="inspiration-skeleton-card__chevron" aria-hidden />
        </div>
    </Card>
);

export default InspirationSkeletonCard;
